import { render, staticRenderFns } from "./objections-icon.vue?vue&type=template&id=3fa6c566"
import script from "./objections-icon.vue?vue&type=script&lang=js"
export * from "./objections-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports